import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const StepperContext = createContext({
  steps: {},
  step: 0,
  setStep: () => {},
});

class Stepper extends React.Component {
  setStep = (step) => {
    const { step: current } = this.state;

    const isPrev = step !== current + 1 && step < current;
    const isNext = step === current + 1;

    if (isPrev || (isNext && !this.props.haveErrors)) {
      this.setState({ step });

      window.scrollTo(0, 0);
    }    
  };

  state = {
    steps: window.MTMReact.steps,
    step: 0,
    setStep: this.setStep,
  };

  render() {
    return (
      <StepperContext.Provider value={this.state}>
        {this.props.children}
      </StepperContext.Provider>
    );
  }
}

Stepper.propTypes = {
  children: PropTypes.node,
  haveErrors: PropTypes.bool,
};

export function StepperConsumer({ children }) {
  return (
    <StepperContext.Consumer>
        {(context) => children(context)}
    </StepperContext.Consumer>
  );
};

export default Stepper;



// WEBPACK FOOTER //
// ./src/Stepper/index.js